<template>
  <div>
    <b-form-input v-model="searchFilter" :placeholder="$t('recherche_label_favoris')" size="sm"></b-form-input>
    <div class="result_search_favoris" v-if="search_favorites.length > 0">
      <div class="result_favoris_item" v-for="(search_fav, index) in search_favorites" :key="index">
        <div class="favoris_nation_col">
          <img class="flag_favoris" :src="'https://sportips.fr/live/img/Flags/' + search_fav.nation + '.jpg'" />
        </div>
        <div class="favoris_info_col">
          <p>
            <b>{{ search_fav.dossard }} {{ search_fav.nom }} {{ search_fav.prenom }}</b>
          </p>
          <p>{{ search_fav.course }}</p>
        </div>
        <div class="favoris_add_col">
          <b-button @click="addFavoris(index)"><b-icon icon="plus"></b-icon></b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      search_favorites: [],
      searchFilter: "",
    };
  },
  watch: {
    searchFilter() {
      if (this.searchFilter != "") {
        this.fetchInscriptions();
      } else {
        this.search_favorites = [];
      }
    },
  },
  methods: {
    addFavoris(index) {
      this.$emit("addFavoris", this.search_favorites[index].id);
      this.searchFilter = "";
      this.search_favorites = [];
    },
    buildEndpoint() {
      var url = "/live/get.php?id=" + this.$store.state.module.id + "&course=all";

      if (this.searchFilter != "") {
        url += "&search=" + this.searchFilter;
      }
      return url;
    },
    fetchInscriptions() {
      var _this = this;
      var endpoint = this.buildEndpoint();
      axios.get(this.$store.state.base_url + endpoint).then(function (response) {
        console.log("LIVE -- Fetch list possible favorites ");
        _this.search_favorites = response.data.list_participants;
      });
    },
  },
  mounted() {},
};
</script>

<style lang="scss">
</style>